import { ProcessQuestionTypeModel } from '../models/questions.model';

export const questionTypes = [
  {
    name: 'process_short_question',
    type: ProcessQuestionTypeModel.FreeText,
    extraFields: {
      yesNo: false,
      alternatives: false,
      filter: false,
      required: true,
    },
  },
  {
    name: 'process_yes_no_question',
    type: ProcessQuestionTypeModel.YesNo,
    extraFields: {
      yesNo: true,
      alternatives: false,
      filter: true,
      required: true,
    },
  },
  {
    name: 'process_multiple_question',
    type: ProcessQuestionTypeModel.MultiChoice,
    extraFields: {
      yesNo: false,
      alternatives: true,
      filter: true,
      required: true,
    },
  },
  {
    name: 'process_video_question',
    type: ProcessQuestionTypeModel.OneWayVideo,
    extraFields: {
      yesNo: false,
      alternatives: false,
      filter: false,
      required: true,
    },
  },
];
